import clsx from 'clsx';
import { ChangeEventHandler, forwardRef, HTMLInputTypeAttribute } from 'react';
import styles from './Input.module.css';

interface InputProps {
  disabled?: boolean;
  errorMessage?: string;
  hasError?: boolean;
  hint?: string;
  label?: string;
  max?: number;
  min?: number;
  name: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  required?: boolean;
  step?: number;
  type?: HTMLInputTypeAttribute | undefined;
  value?: string | ReadonlyArray<string> | number | undefined;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ disabled, errorMessage, hasError, hint, label, max, min, name, onChange, placeholder, required, step, type = 'text', value }: InputProps, ref) => {
    const id = `input-${name}`;
    const error = Boolean(errorMessage) || hasError;

    return (
      <div className={styles.container}>
        {label && (
          <label className={clsx(styles.label, error && styles.error)} htmlFor={id}>
            {label} {required && <span>*</span>}
          </label>
        )}
        <input
          className={clsx(styles.input, error && styles.error)}
          disabled={disabled}
          id={id}
          max={max}
          min={min}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          ref={ref}
          step={step}
          type={type}
          value={value}
        />
        {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
        {hint && !errorMessage && !hasError && <div className={styles.hint}>{hint}</div>}
      </div>
    );
  },
);

Input.displayName = 'Input';

export default Input;
